module.exports = __webpack_public_path__ + "img/popup_standard_pay_select.944e0e6e.png";